import { render } from "./RoomsPage.vue?vue&type=template&id=0f8223b3"
import script from "./RoomsPage.vue?vue&type=script&lang=js"
export * from "./RoomsPage.vue?vue&type=script&lang=js"

import "@/css/GuestsPage.css?vue&type=style&index=0&lang=css&external"
import "@/css/RoomsPage.css?vue&type=style&index=1&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__